import { AttachmentType } from "../../common";
import { DEFAULT_ATTACHMENT_ID } from '../constants';
export function getFilteredAttachmentsSuccessReducer(state, action) {
    let retainedAttachmentByIds = {};
    const retainedAttachmentAllIds = [];
    const retainedSelectedIds = new Set();
    for (const id of state.allIds) {
        const attachment = state.byId[id];
        // we are doing the below so that we can retain any attachments that aren't user uploaded and are auto-generated
        // e.g. EST_PDF, MBMS_ESTIMATE, EMS_ESTIMATE etc.
        if (attachment.type !== AttachmentType.IMAGE &&
            attachment.type !== AttachmentType.THUMBNAIL &&
            attachment.type !== AttachmentType.DAT) {
            retainedAttachmentByIds = Object.assign(Object.assign({}, retainedAttachmentByIds), { [id]: attachment });
            retainedAttachmentAllIds.push(id);
        }
    }
    action.payload.attachments.forEach(attachment => {
        if (attachment.id !== DEFAULT_ATTACHMENT_ID) {
            retainedAttachmentAllIds.push(attachment.id);
            retainedAttachmentByIds = Object.assign(Object.assign({}, retainedAttachmentByIds), { [attachment.id]: attachment });
        }
        if (state.selectedIds.has(attachment.id)) {
            retainedSelectedIds.add(attachment.id);
        }
    });
    return {
        byId: retainedAttachmentByIds,
        allIds: retainedAttachmentAllIds,
        attachmentPairs: action.payload.attachmentPairs,
        selectedIds: retainedSelectedIds
    };
}
//# sourceMappingURL=getFilteredAttachmentsSuccessReducer.js.map